<script setup></script>

<template>
  <RouterView :key="$route.fullPath" />
</template>

<style lang="scss" scoped></style>
